import { MessageSquare } from 'lucide-react'
import React from 'react'

const Allinclusive = () => {


    const features = [
    { icon: "🗄️", title: 'Cabinets', description: 'Premium quality cabinets custom-built to your specifications' },
    { icon: "🪨", title: 'Countertops', description: 'Durable and beautiful countertop installation' },
    { icon: "🧱", title: 'Backsplash', description: 'Professional backsplash design and installation' },
    { icon: "🎨", title: 'Paint', description: 'Complete painting services for your kitchen' },
    { icon: "🚰", title: 'Sink', description: 'High-quality sink installation with plumbing' },
    { icon: "🔩", title: 'Hardware', description: 'Knobs, pulls, and all finishing hardware' },
    { icon: "⚡", title: 'Electrical', description: 'Any necessary electrical work included' },
    { icon: "👷", title: 'Complete Labor', description: 'Full installation from start to finish' }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8" style={{ background: "var(--gradient-bg)" }}>
            <div className="max-w-7xl mx-auto">
              {/* Section Header */}
              <div className="text-center mb-8 sm:mb-12">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
                  style={{
                    background: "var(--bg-primary-10)",
                    border: "1px solid var(--border-primary-20)",
                  }}
                >
                  <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
                  <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                    Complete Package Zero Stress.
                  </span>
                </div>
                
                <h2 className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-primary-500)" }}>
                  All-Inclusive Kitchen Transformation
                </h2>
                
                <p className="inter-secondary text-base sm:text-lg max-w-3xl mx-auto px-4" style={{ color: "var(--color-gray-600)" }}>
                  Everything you need for a complete kitchen renovation, handled by our expert team from start to finish.
                </p>
    
                {/* Decorative Line */}
                <div className="flex justify-center mt-6" aria-hidden="true">
                  <div 
                    className="w-24 h-1 rounded-full"
                    style={{
                      background: "var(--gradient-primary)",
                    }}
                  ></div>
                </div>
              </div>
    
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 px-2 sm:px-0">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="group bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                    style={{
                      backgroundColor: "var(--color-white)",
                      borderColor: "var(--border-light)",
                      boxShadow: "var(--shadow-medium)",
                    }}
                  >
                    {/* Icon and Title - Inline */}
                    <div className="flex items-center gap-3 mb-3">
                      {/* Icon Container */}
                      <div
                        className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                        style={{
                          backgroundColor: "var(--color-primary-500)",
                        }}
                      >
                        <span
                          className="text-2xl sm:text-3xl"
                          style={{ color: "var(--color-primary-600)" }}
                        >
                          {feature.icon}
                        </span>
                      </div>
    
                      {/* Title */}
                      <h3
                        className="bell-mt-primary text-base sm:text-lg font-semibold"
                        style={{ color: "var(--color-primary-500)" }}
                      >
                        {feature.title}
                      </h3>
                    </div>
    
                    {/* Description */}
                    <p className="inter-secondary text-xs sm:text-sm" style={{ color: "var(--color-gray-600)" }}>
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
    
              <div 
                className="rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 text-center relative overflow-hidden"
                style={{
                  background: "var(--gradient-primary)",
                }}
              >
                {/* Background Decorative Elements */}
                <div 
                  className="absolute top-0 left-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
                  aria-hidden="true"
                  style={{
                    backgroundColor: "var(--color-white)",
                  }}
                ></div>
                <div 
                  className="absolute bottom-0 right-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full translate-x-1/2 translate-y-1/2 opacity-20 blur-3xl" 
                  aria-hidden="true"
                  style={{
                    backgroundColor: "var(--color-white)",
                  }}
                ></div>
    
                <div className="relative z-10 max-w-4xl mx-auto">
                  <h3 className="bell-mt-primary text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-white)" }}>
                    Complete Package. Zero Stress.
                  </h3>
                  <p className="inter-secondary text-sm sm:text-base md:text-lg mb-4 sm:mb-6 px-2" style={{ color: "rgba(255, 255, 255, 0.9)" }}>
                    Our all-inclusive service includes cabinets, countertops, backsplash, paint, sink, 
                    knobs and all materials needed to finish your kitchen. We handle the entire labor 
                    to install kitchen, countertops, backsplash, any electric and plumbing work.
                  </p>
                  <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
                    {["No Hidden Costs", "Single Point of Contact", "Guaranteed Timeline"].map((text, i) => (
                      <div 
                        key={i}
                        className="backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm"
                        style={{
                          backgroundColor: "var(--bg-white-10)",
                          border: "1px solid var(--border-white-10)",
                        }}
                      >
                        <span className="font-semibold" style={{ color: "var(--color-white)" }}>{text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
  )
}

export default Allinclusive